import React, { Component } from 'react'

// ui
import Modal from '../../components/feedback/modal'
import Button from '../../components/uielements/button'

// redux
import { connect } from 'react-redux'
import roleActions from '../../redux/qbrole/actions'

class ModalConfirmDelete extends Component {

    _handleOK = () => {
        this.props.deleteRole(this.props.role.role_id)
        this.props.dismiss()
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    render(){
        const { visible } = this.props
        return (
            <Modal
                visible={visible}
                title="Xác nhận xoá quyền người dùng"
                onOk={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                centered
                footer={[
                    <Button 
                        style={{ backgroundColor: '#b3e6ff' }}
                        onClick={() => this._handleCancel()}
                    >
                        Không
                    </Button>,
                    <Button
                        style={{ backgroundColor: '#ff9999' }}
                        onClick={() => this._handleOK()}
                    >
                        Xoá
                    </Button>,
                ]}
            >
                <p>Bạn có chắc chắn xoá quyền người dùng này không?</p>
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        visible: state.qbrole.modalConfirmDeleteRole,
        role: state.qbrole.currentRole
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(roleActions.action.dismissModalConfirmDeleteRole())
        },
        deleteRole: roleId => {
            dispatch(roleActions.action.deleteRole(roleId))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalConfirmDelete)